import * as React from "react";
import { Button, Grid } from "components/controls/widget";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import YesNoDialog, { YesNoDialogProps } from "common/components/controls/YesNoDialog"
import { NovyPrestup as apiNovyPrestup, NovyPrest } from "common/api/Evidence/Clenove/Prestupy";
import apiOznameniPrestupu, { OznData } from "common/api/SendEmailNotifications/OznameniPrestupu";
import PrestupyUtils from "common/utils/PrestupyUtils";
import Error from "common/components/controls/Error";
import { detail as pathDetail, RouteProps } from "./routes-path";


export interface NovyPrestupProps {
    idtClena: number;
}

interface State {
    showDialog: boolean;
    submitting?: boolean;
    hasError: boolean;
    error?: React.ReactNode;
}

type Props = NovyPrestupProps & State & ActionsExecutorPropsType & RouteComponentProps<RouteProps>;


const initialState: State = {
    showDialog: false,
    hasError: false,
}

class NovyPrestup extends React.Component<Props> {

    handleClose = (cancel: boolean) => {
        if (cancel) {
            this.showDialog(false);
        } else {

            const { updateState, executeAction, idtClena } = this.props

            const action1 = apiNovyPrestup()
                .onSuccess(p => {
                    const action2 = apiOznameniPrestupu()
                        .onSuccess(() => this.goToDetail(p.id))
                        .onError(() => this.goToDetail(p.id));
                    executeAction(action2, {}, { prestupId: p.id, typZpravy: PrestupyUtils.TypZpravy_PorizeniPrestupu })
                })
                .onValidationFailed(e => this.setError(e['_error']))
                .onError(e => this.setError(e.message));

            executeAction(action1, { submitting: true, hasError: false, error: undefined }, { idtClena: idtClena.toString(), overit_clena: false });
        }
    }

    setError = (error: string | string[]) => {
        this.props.updateState({ submitting: false, hasError: true, error: error });
    }

    goToDetail = (prestupId: number) => {
        const { history, match } = this.props;
        this.showDialog(false);
        const path = match.url + pathDetail + '/' + prestupId;
        history.push(path);
    }

    showDialog = (show: boolean) => {
        if (this.props.showDialog !== show) {
            this.props.updateState({ submitting: false, showDialog: show, hasError: false, error: undefined });
        }
    }

    render() {
        const { showDialog, hasError, error, submitting } = this.props;

        const dlgProps: YesNoDialogProps = {
            show: showDialog,
            submitting: submitting,
            handleClose: this.handleClose,
            title: 'Přestup do divize',
            fullWidth: true,
            maxWidth: 'sm',
        }

        return <React.Fragment>
            <Button color="primary" variant="outlined" onClick={() => this.showDialog(true)}>
                {'Přestoupit do divize'}
            </Button>
            <YesNoDialog {...dlgProps}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu chcete přestoupit do divize?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
        </React.Fragment>
    }
}

export default withActionsExecutor<NovyPrestupProps, State>(initialState, withRouter(NovyPrestup));